// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_cl-b";
export var colorBlue = "_cl-8";
export var colorDot = "_cl-0";
export var colorDotLarge = "_cl-2";
export var colorDotSmall = "_cl-1";
export var colorGreen = "_cl-7";
export var colorGrey = "_cl-3";
export var colorOrange = "_cl-5";
export var colorPink = "_cl-a";
export var colorPurple = "_cl-9";
export var colorRed = "_cl-4";
export var colorYellow = "_cl-6";